// extracted by mini-css-extract-plugin
export default {"container":"jr2l6jxhgfBTtW0","send-sms-code-button":"WKk2JEE5Csybenm","inline":"HPlqorDeHYwYd2l","title":"AqQC204HC4wNV1O"};